module.exports = __webpack_public_path__ + "img/labmem_text_language_tc.14990a5e.png";